import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/tailwind.css';
import { setAuthToken } from './services/api';

// Si hay token guardado, aplicarlo a las cabeceras por defecto
const token = localStorage.getItem('token');
if (token) setAuthToken(token);

// Esperamos a que el router resuelva la ruta inicial antes de montar: si
// montamos antes, `isHomeRoute` es false por un instante (el nombre de ruta
// todavía no está definido) y el header alcanza a mostrarse completo en
// móvil antes de ocultarse, causando un parpadeo visible.
const app = createApp(App).use(router);
router.isReady().then(() => {
  app.mount('#app');
});
